module.exports = __webpack_public_path__ + "img/somnium_signup.78522dd5.webp";